export default {
	SET_SHOWNOTIFICATION_TRUE(state) {
		state.showNotification = true;
	},

	SET_SHOWNOTIFICATION_FALSE(state) {
		state.showNotification = false;
	}
};
